<form novalidate [formGroup]="form"  (keyup.enter)="onFormSubmit()" (ngSubmit)="onFormSubmit()" class="form">
  
  <ion-list>

    <ion-item class="ion-no-padding" mode="md">
      <ion-label position="stacked" mode="md">{{ 'LOGIN.EMAIL' | translate }}</ion-label>
      <ion-input formControlName="email" (focus)="emailFocus=true;" (blur)="emailFirstBlur=true; emailFocus=false;" type="email" tabindex="10" [ngClass]="{
        'is-invalid': email.invalid && ( emailFirstBlur || tryToSubmit )
      }"></ion-input>

    </ion-item>
    <div class="invalid-feedback" *ngIf="email.invalid && ( emailFirstBlur || tryToSubmit ) && !!email.errors?.required">
      E-pošta je obvezna.
    </div>
    <div *ngIf="email.invalid && !emailFocus && !!email.errors?.pattern && !email.errors?.required">
      E-pošta ni v pravilnem formatu.
    </div>

    <ion-item class="ion-no-padding" mode="md">
      <ion-label position="stacked" mode="md">{{ 'LOGIN.PASSWORD' | translate }}</ion-label>
      <ion-input formControlName="password" (focus)="passwordFocus=true;" (blur)="passwordFirstBlur=true; passwordFocus=true" class="form-control is-invalid" tabindex="11" [type]="showPassword ? 'text' : 'password'" [ngClass]="{
          'is-invalid': password.invalid && password.errors?.required && tryToSubmit
        }"></ion-input>
        <a class="form-icon-holder">
          <ion-icon name="eye" *ngIf="!showPassword" (click)="showPassword=true"></ion-icon>
          <ion-icon name="eye-off" *ngIf="showPassword" (click)="showPassword=false"></ion-icon>
        </a>

    </ion-item>
    <div *ngIf="password.invalid && password.errors?.required && tryToSubmit">
      Geslo je obvezno.
    </div>

    <div class="form-checkbox">
      <div class="form-checkbox__cb-wrapper ion-float-left">
        <ng-container *ngIf="false">
          <ion-checkbox name="remember_me" mode="md"></ion-checkbox>
          <ion-label>{{ 'LOGIN.REMEMBER_ME' | translate }}</ion-label>
        </ng-container>
      </div>
      <div class="ion-float-right">
        <p>
          <a class="pp-link"  [queryParamsHandling]="'preserve'" [routerLink]="['/auth', 'pozabljeno-geslo']">{{ 'LOGIN.FORGOTTEN_PASSWORD' | translate }}</a>
        </p>
      </div>
    </div>

  </ion-list>

  <ion-button *ngIf="!(loading$ | async)" type="submit" [disabled]="!form.valid" expand="full" tabindex="12" class="btn--large" tabindex="12"> {{ 'LOGIN.BTN_EMAIL_LOGIN' | translate }}  </ion-button>
  <ion-button *ngIf="loading$ | async" type="submit" disabled="true" expand="full" tabindex="12" class="btn--large" tabindex="12"><ion-spinner name="crescent"></ion-spinner></ion-button>
</form>

<ion-item  class="ion-no-padding">
  <p class="ion-text-center register-prompt">{{ 'LOGIN.NO_ACCOUNT_YET' | translate }} <a [routerLink]="['/auth', 'registracija']" class="pp-link">{{ 'LOGIN.REGISTER' | translate }}</a>
  </p>
</ion-item>

<!-- guest login -->
<ion-button style="border:3px solid black;" *ngIf="returnUrl && ( returnUrl.includes('capra') || returnUrl.includes('hisa-pod-gradom') )" fill="clear" class="btn--large" mode="md" (click)="onNoLogin()" expand="full">
   <!--ion-icon class="facebook"></ion-icon-->
   <span style="color:black">{{ 'LOGIN.NO_LOGIN_BTN' | translate }}</span>
</ion-button>


<p class="ion-text-center text--tos">{{ 'LOGIN.DISCLAIMER' | translate }}<br>{{ 'LOGIN.DISCLAIMER_MORE' | translate }}<a [routerLink]="['/info', 'zasebnost']">{{ 'LOGIN.DISCLAIMER_POLICY' | translate }}</a>.</p>